// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBtTRLAKqwtxuMcgowJ3KVkkVqqaW4C3kc",
  authDomain: "dahira-cap-web.firebaseapp.com",
  projectId: "dahira-cap-web",
  storageBucket: "dahira-cap-web.appspot.com",
  messagingSenderId: "1040793668718",
  appId: "1:1040793668718:web:78c34b943371d367f96a7f"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore();